import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddStoreControlBody, OnBoardNewStore, OwnsMenuValues, StoreControlResponse } from './storeControl.types';

export const useStores = (cacheTime: number = 0) => {
  return useQuery<AxiosResponse<StoreControlResponse[], any>>({ 
    queryKey: "storeControl",
    queryFn: () => apiClient.get<StoreControlResponse[]>('/store-controls/'),
    cacheTime: cacheTime,
  });
};

export const useAllStores = (enabled: boolean = true, cacheTime = 0) => {
  return useQuery<AxiosResponse<StoreControlResponse[], any>>({
    queryKey: 'storeControlsForOnboarding',
    queryFn: () => apiClient.get<StoreControlResponse[]>(`/New-StoreInfo`),
    enabled,
    retry: (failureCount) => failureCount < 3,
    cacheTime
  });
};

export const useStoreControlRecord = (storeNo: string | undefined, enabled: boolean = false) => {
  return useQuery<AxiosResponse<StoreControlResponse, any>>({
    queryKey: 'storeControls',
    queryFn: () => apiClient.get<StoreControlResponse>(`/store-controls/${storeNo}`),
    enabled,
  });
};

export const useAddStoreControlRecord = () => {
  return useMutation((record: AddStoreControlBody) => {
    return apiClient.post(`/store-controls`, record);
  });
};

export const useOnBoardNewStore = () => {
  return useMutation((record: OnBoardNewStore) => {
    return apiClient.post(`/store-controls/onboard`, record);
  });
};

export const useEditStoreControlRecord = (storeNo: string) => {
  return useMutation((record: StoreControlResponse) => {
    return apiClient.put(`/store-controls/${storeNo}`, record);
  });
};

export const fetchSourceStores = async (
  requestBody: { storeNo: string; },
  onSuccess: (response: AxiosResponse) => void
) => {
  const response = await apiClient.get<OwnsMenuValues[]>('/store-controls/owns-menus', { params: requestBody });
  onSuccess(response);
};